// extracted by mini-css-extract-plugin
export var colored = "styles-module--colored--a4585";
export var light = "styles-module--light--689e4";
export var link = "styles-module--link--06d95";
export var underlined = "styles-module--underlined--93235";